<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible" :before-close="handleClose">
    <el-tabs>
            <el-form :model="dataForm" ref="dataForm" :rules="dataRule" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="物料编码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="matnr">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.matnr" placeholder="物料编码" size="small"></el-input>
                                <span v-else>{{dataForm.matnr}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="werks">
                                <span v-if="viewFlag === 'view'">{{dataForm.werks}}</span>
                                <el-select v-else v-model="dataForm.werks" filterable placeholder="请选择工厂" style="width:100%">
                                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="起始时间:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="vdatu">
                                <el-date-picker v-if="viewFlag !== 'view'" v-model="dataForm.vdatu" type="date" value-format="yyyy-MM-dd" :clearable="false" :picker-options="pickerOptions0">
                                </el-date-picker>
                                <span v-else>{{dataForm.vdatu}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="有效至:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="bdatu">
                                <el-date-picker v-if="viewFlag !== 'view'" v-model="dataForm.bdatu" type="date" value-format="yyyy-MM-dd" :clearable="false" :picker-options="pickerOptions1">
                                </el-date-picker>
                                <span v-else>{{dataForm.bdatu}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="最小分拆量:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="scmng">
                                  <el-input-number v-if="viewFlag !== 'view'" v-model="dataForm.scmng" :min="0" :max="999999" ></el-input-number>
                                <span v-else>{{dataForm.scmng}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <span  v-if="viewFlag !== 'view'" style="color: red;font-size: 12px;float:right;line-height: 30px;margin-right: 20px;">* 点击表格中配额、特别采购类型进行编辑</span>
                <el-table-edit :model="detailList" :columns="['lifnr','quote','sobin']" ref="editTable">
                <el-table :data="detailList" size="small" border style="width: 100%;" :default-expand-all="false" ref="table" :header-cell-style="{background:'#f5f5f5'}" :row-class-name="rowClassName" class="mb15" @row-dblclick="editAll">
                    <el-table-column type="index" width="50" label="序号" size="small">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="lifnr" header-align="center" align="center" label="供应商" size="small" :rules='dataRule.lifnr'>
                        <template slot-scope="scope">
                            <el-input v-if="scope.row.show && viewFlag !== 'view'" v-model="scope.row.lifnr" placeholder="供应商" size="small"></el-input>
                            <span v-else>{{scope.row.lifnr}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierName" header-align="center" align="center" label="供应商名称" size="small" :rules='dataRule.lifnr'>
                        <template slot-scope="scope">
                            <span>{{scope.row.supplierName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quote" header-align="center" align="center" label="配额" size="small">
                        <template slot-scope="scope">
                            <el-input-number @input.native="onInput0_100" v-if="scope.row.lifnr != null && scope.row.lifnr != '' && viewFlag !== 'view'" v-model="scope.row.quote" placeholder="配额" size="small" :min="0" :max="100"></el-input-number>
                            <span v-else>{{scope.row.quote}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sobin" header-align="center" align="center" label="特别采购类型" size="small">
                        <template slot-scope="scope">
                            <el-select v-if="scope.row.lifnr != null && scope.row.lifnr != '' && viewFlag !== 'view'" v-model="scope.row.sobin" placeholder="请选择" size="small">
                                <el-option v-for="item in SOBIN_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{getSboinByValue(scope.row.sobin)}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateDetailHandle(scope.row.id)" icon="el-icon-edit">
                                修改
                            </el-button>
                            <el-button type="text" size="small" @click="deleteDetail(scope.row.id)" icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                </el-table-edit>
                <el-row :gutter="40">
                        <el-col :span="24" style="text-align:right;">
                            <el-button size="small" @click="cancel()">
                                取消
                            </el-button>
                            <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()" :loading="loading">
                                保存
                            </el-button>
                        </el-col>
                </el-row>
            </el-form>
    </el-tabs>
    <add-or-update-detail v-if="addOrUpdateDetailVisibe" ref="addOrUpdateDetail" @refreshDetailDataList="fetchQuotaMaterialDetailList"></add-or-update-detail>
</el-dialog>
</template>

<script>
import Vue from 'vue'
import {
    editQuotaMaterial,
    createQuotaMaterial,
    getQuotaMaterialById,
    fetchQuotaMaterialDetailList,
    deleteQuotaMaterialDetail,
    getFactoryList,
} from '@/controller/systemData'
import AddOrUpdateDetail from './quotaMaterial-detail-add-or-update'
import {
    SOBIN_TYPE,
    getSboinByValue,
} from "@/utils/const";
import moment from 'moment'
import { number } from 'echarts';
// require('@/mock/mockProject');
export default {
    computed: {
      editTable() {
        return this.$refs.editTable
      }
    },
    data() {
        return {
            pickerOptions0: {
                disabledDate: (time) => {
                    return time.getTime() >  new Date(this.dataForm.bdatu).getTime();
                }
            },
            pickerOptions1: {
                disabledDate: (time) => {
                    return time.getTime() < new Date(this.dataForm.vdatu).getTime()- 1*24*60*60*1000;//减去一天的时间代表可以选择同一天;
                }
            },
            loading: false,
            show:false,
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            factoryList: [],
            unitList: [],
            detailList: [],
            SOBIN_TYPE : SOBIN_TYPE,
            getSboinByValue:getSboinByValue,
            storePositionTypeList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataForm: {
                id: 0,
                matnr: '',
                werks: '',
                scmng: '',
                vdatu: '',
                bdatu: '',
                zguid:'',
                quotaMaterialDetailDTOList: [],
            },
            addOrUpdateDetailVisibe: false,
            zguid:'',//32位唯一标识
            dataRule: {
                matnr: [{
                    required: true,
                    message: '请输入物料编码',
                    trigger: "blur",
                }],
                lifnr: [{
                    required: true,
                    message: '请输入供应商编码'
                }]
            },
        }
    },
    mounted() {},
    components: {
        AddOrUpdateDetail
    },
    // activated() {
    //     this.init()
    //     this.fetchQuotaMaterialDetailList()
    //     this.getFactoryList()
    // },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.zguid = data.zguid;
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getQuotaMaterialById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                        }
                    });
                    this.fetchQuotaMaterialDetailList()
                    this.getFactoryList()
                }
            })
        },
        cancel(){
            this.viewData.visible = false 
            this.$emit('refreshDataList')
        },
        handleClose(){
            this.viewData.visible = false 
            this.$emit('refreshDataList')
        },
        // 表单提交
        dataFormSubmit() {
            //校验必填
            if(!this.detailList[0].lifnr){
                this.$message.error("第1行供应商，不可为空")
                return
            }
            if(!this.detailList[0].quote){
                this.$message.error("第1行配额，不可为空")
                return
            }
            if(this.detailList[0].sobin == null){
                this.$message.error("第1行特别采购类型，不可为空")
                return
            }
            for(var i=1; i<this.detailList.length;i++){
                if(!(!this.detailList[i].lifnr && !this.detailList[i].quote && !this.detailList[i].sobin)){
                    var index = i+1;
                   if(!this.detailList[i].lifnr){
                        this.$message.error("第"+index+"行供应商，不可为空")
                        return
                    }
                    if(!this.detailList[i].quote){
                        this.$message.error("第"+index+"行配额，不可为空")
                        return
                    }
                    if(this.detailList[i].sobin == null){
                        this.$message.error("第"+index+"行特别采购类型，不可为空")
                        return
                    }
                }
            }
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 1000)
            this.$refs['dataForm'].validate((valid) => {
                this.dataForm.quotaMaterialDetailDTOList = this.detailList
                let params = this.dataForm
                if (valid) {
                    if (this.dataForm.id) {
                        editQuotaMaterial(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.fetchQuotaMaterialDetailList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.fetchQuotaMaterialDetailList();
        },
        fetchQuotaMaterialDetailList() {
            fetchQuotaMaterialDetailList({
                zguid:this.zguid,
                historyId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.detailList = data.body.records;
                    if(data.body.records.length<5){
                        for (let index = 0; index < 5; index++) {
                            this.detailList.push({id:null});
                            if(this.detailList.length == 5){
                                return;
                            }
                        }
                    }
                } 
            });
        },
        //删除detail
        deleteDetail(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteQuotaMaterialDetail({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.fetchQuotaMaterialDetailList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                })
                .catch(() => {});
        },
        // 新增 / 修改
        addOrUpdateDetailHandle(id) {
            this.addOrUpdateDetailVisibe = true
            this.$nextTick(() => {
                this.$refs.addOrUpdateDetail.init(id, this.dataForm.id)
            })
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        // getFactoryName(val) {
        //     const factory = this.factoryList.find(factory => factory.factoryCode === val)
        //     return factory ? factory.factoryDesc : ''
        // },
        getStyle() {
            return 'width: 160px; text-align: right'
        },
        getStyle2() {
            return 'width: 395.5px;'
        },
        editAll() {
            //debugger
            this.detailList.map((i, index) => {
            i.show = true
            Vue.set(this.detailList, index, i)
            })
        },
        rowClassName({
                     row,
                     rowIndex
                   }) {
            row.rowid = rowIndex + 1;
        },
        onInput0_100(e){
            this.$message.closeAll();
            // 验证是否是纯数字
            let isNumber = /^\d*$/.test(e.target.value);
            // 过滤非数字
            e.target.value = e.target.value.replace(/\D/g, "");
            if (!isNumber || e.target.value < 0 || e.target.value > 100) {
                this.$message.warning("只能输入[0,100]区间的整数");
            }
            e.target.value = (e.target.value >= 0 && e.target.value <= 100 && e.target.value.match(/^\d*/g)[0]) || null;
        }
    },
}
</script>
